<template>
<!-- 字典管理 -->
<div>
  <div v-if="watchFormVisble">
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
      </div>
      <el-collapse-transition>
      <div style="padding:0px 12px" v-show="show3">
      <el-form class="findform">
        <!-- 顶部搜索框 -->
        <el-form-item label="字典名称：" style="display:flex;width:30%;">
          <el-input v-model="zdmc" placeholder="请输入字典名称" style="width:90%"/>
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!--列表-->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">数据字典</p>
        <el-button type="danger" @click="addEditor('',1)" style="float: right;margin: 5px 10px 0 0;">新增</el-button>
      </section>
      <div class="table_container">
        <el-table :data="sjzdList" stripe border>
          <el-table-column label="序号" width="60" align="center">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <el-table-column label="字典名称" align="center">
            <template scope="scope">{{scope.row.ApplyTime}}</template>
          </el-table-column>
          <el-table-column label="字典类型" align="center">
            <template scope="scope">{{scope.row.Rise}}</template>
          </el-table-column>
          <el-table-column label="字典描述" align="center">
            <template scope="scope">{{scope.row.Amount}}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="200">
            <template scope="scope">
              <span class="handle" @click="peizhi(scope.row)">
                <i class="el-icon-s-operation"></i> 配置
              </span>
              <span class="handle" @click="addEditor(scope.row,2)">
                <i class="el-icon-edit-outline"></i> 编辑
              </span>
              <span class="handle" @click="deleteMerchant(scope.row)">
                <i class="el-icon-delete"></i> 删除
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
        :page-size="10" :total="totalOne" :current-page="pageIndex" style="float:right;margin:10px 0;"/>
      </div>
    </div>
  </div>
  <!--详情-->
  <div class="main_container" v-else>
    <section class="model_section">
      <p class="model_top_title">字典配置</p>
      <el-button type="danger" @click="addEditor('',3)" style="float: right;margin: 5px 10px 0 0;">新增</el-button>
    </section>
    <div class="table_container">
      <el-table :data="zdpzList" stripe border>
        <el-table-column label="序号" width="60" align="center">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="字典参数名称" align="center">
          <template scope="scope">{{scope.row.ApplyTime}}</template>
        </el-table-column>
        <el-table-column label="字典参数值" align="center">
          <template scope="scope">{{scope.row.Rise}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="200">
          <template scope="scope">
            <span class="handle" @click="addEditor(scope.row,4)">
              <i class="el-icon-edit-outline"></i> 编辑
            </span>
            <span class="handle" @click="deleteMerchant(scope.row)">
              <i class="el-icon-delete"></i> 删除
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="currentChangeTwo"
      :page-size="10" :total="totalTwo" :current-page="pageTwoIndex" style="float:right;margin:10px 0;"/>
    </div>
    <div style="clear:both;text-align:center;margin: 10px 0 20px 0;"> <el-button @click="closeModal()">返回</el-button> </div>
  </div>

  <!-- 新增/编辑推广-弹框 -->
  <el-dialog :title="popUptitle" :visible.sync="invoiceFormVisible" :center="true" width="30%">
    <el-form v-if="difference==1||difference==2">
      <el-form-item label="字典名称 :" style="width:80%" label-width="80px">
        <el-input v-model="brandName" placeholder="请输入字典名称" maxlength="20"/>
      </el-form-item>
      <el-form-item label="字典类型 :" style="width:80%" label-width="80px">
        <el-input v-model="fapaiostate" placeholder="请输入字典类型" maxlength="20"/>
      </el-form-item>
      <el-form-item label="字典描述 :" style="width:80%;" label-width="80px">
        <el-input type="textarea" v-model="anwser" placeholder="最多输入50个字"
        :autosize="{ minRows: 2, maxRows: 8}" maxlength="50" show-word-limit/>
      </el-form-item>
    </el-form>
    <el-form v-else>
      <el-form-item label="参数名称 :" style="width:80%" label-width="80px">
        <el-input v-model="canshuName" placeholder="请输入参数名称" maxlength="20"/>
      </el-form-item>
      <el-form-item label="参数值 :" style="width:80%" label-width="80px">
        <el-input v-model="canshuzhi" placeholder="请输入参数值" maxlength="20"/>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div style="text-align:center">
      <el-button @click="invoiceFormVisible = false">取消</el-button>
      <el-button type="danger" @click="editSubmit()">保存</el-button>
    </div>
  </el-dialog>

</div>
</template>
<script>
import { seefapai } from "../../api/api";
import { getGuessYouLike } from "../../api/comment";
export default {
  data() {
    return {
      show3:false,
      watchFormVisble: true, // 列表详情切换
      zdmc: "", // 关键词语
      sjzdList: [], // 数据字典
      pageIndex: 1,
      totalOne: 0, // 总条数
      zdpzList: [], // 字典配置
      pageTwoIndex: 1,
      totalTwo: 0, // 总条数

      difference: '', // 区分模块
      invoiceFormVisible: false, // 新增&编辑
      popUptitle: '', // 数据字典 标题
      editornotid: '', // id

      brandName: '', // 字典名称
      fapaiostate: '', // 字典类型
      anwser: '', // 字典描述
      
      canshuName: '', // 参数名称
      canshuzhi: '', // 参数值
    };
  },
  methods: {
    // 获取 数据字典 列表
    initOne() {
      let addParams = {
        // operId: localStorage.Id,
        Keyword: '', // 关键词
        MediaType: 0, // 类型
        pageIndex: this.pageIndex,
        pageSize: 10,
      };
      getGuessYouLike(addParams).then(data => {
        if(data.resultCode == 1){
          this.sjzdList = data.resultObj.resultObj;
          this.totalOne = data.resultObj.rowsCount;
        }else{
          this.$swal({
            type: "warning",
            text: data.resultMsg,
          });
        }
      }).catch(err => {
        this.sjzdList = [];
        this.totalOne = 0;
      });
    },
    // 分页1
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.initOne();
    },
    // 获取 字典配置 列表
    initTwo() {
      let addParams = {
        // operId: localStorage.Id,
        Keyword: '', // 关键词
        MediaType: 0, // 类型
        pageIndex: this.pageTwoIndex,
        pageSize: 10,
      };
      getGuessYouLike(addParams).then(data => {
        if(data.resultCode == 1){
          this.zdpzList = data.resultObj.resultObj;
          this.totalTwo = data.resultObj.rowsCount;
        }else{
          this.$swal({
            type: "warning",
            text: data.resultMsg,
          });
        }
      }).catch(err => {
        this.zdpzList = [];
        this.totalTwo = 0;
      });
    },
    // 分页2
    currentChangeTwo(val) {
      this.pageTwoIndex = val;
      this.initTwo();
    },
    // 弹窗:新增 & 编辑
    addEditor(row, type) {
      this.difference=type; // 区分 数据字典 and 字典配置
      this.invoiceFormVisible = true;
      if(row){
        this.popUptitle='编辑';
        this.editornot(); // 调用回显接口
        if(type==1||type==2){
          this.editornotid = row.OrderId; // id
          this.brandName = row.brandName; // 字典名称
          this.fapaiostate = row.StatusName; // 字典类型
          this.anwser = row.anwser; // 字典描述
        }else{
          this.editornotid = row.OrderId; // id
          this.canshuName = row.canshuName; // 参数名称
          this.canshuzhi = row.canshuzhi; // 参数值
        }
      }else{
        this.popUptitle='新增';
        this.editornotid = ''; // id
        if(type==1||type==2){
          this.brandName = ''; // 字典名称
          this.fapaiostate = ''; // 字典类型
          this.anwser = ''; // 字典描述
        }else{
          this.canshuName = ''; // 参数名称
          this.canshuzhi = ''; // 参数值
        }
      }
    },
    // 回显信息
    editornot() {
      var loginParams = {
        id: this.editornotid
      };
      seefapai(loginParams).then(data => {
        data = data.ResultObj;
      }).catch(err => {
        console.log(err);
      });
    },
    // 保存
    editSubmit() {
      if(this.difference==1||this.difference==2){
        if (this.brandName == "") {
          this.$swal({
            type:"warning",
            text:"请输入字典名称"
          })
          return false;
        }
        if (this.fapaiostate == "") {
          this.$swal({
            type:"warning",
            text:"请输入字典类型"
          })
          return false;
        }
        if (this.anwser == "") {
          this.$swal({
            type:"warning",
            text:"请输入字典描述"
          })
          return false;
        }
      }else{
        if (this.canshuName == "") {
          this.$swal({
            type:"warning",
            text:"请输入参数名称"
          })
          return false;
        }
        if (this.canshuzhi == "") {
          this.$swal({
            type:"warning",
            text:"请输入参数值"
          })
          return false;
        }
      }
      let obj = {
        activityId: row.Id
      };
      getDeleteActivity(obj).then(data => {
        if (data.ResultCode == 1) {
          this.$swal({
            type: "success",
            text: "操作成功",
          });
          this.invoiceFormVisible = false;
          this.getActiveList();
        }
      });
    },
    // 删除
    deleteMerchant(row) {
      this.$swal({
        type: "warning",
        text: "重要信息，你确定要删除吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          let obj = {
            activityId: row.Id
          };
          getDeleteActivity(obj).then(data => {
            if (data.ResultCode == 1) {
              this.$swal({
                type: "success",
                text: "删除成功",
              });
              this.getActiveList();
            }
          });
        }
      });
    },
    // 查询
    onSubmit() {
      this.pageIndex = 1;
      this.initOne();
    },
    // 重置
    fnReset() {
      this.zdmc = "";
    },
    // 配置
    peizhi(row) {
      this.watchFormVisble = false; // 进入 字典配置 列表
      this.initTwo();
    },
    // 返回列表
    closeModal() {
      this.watchFormVisble = true; // 回到列表页
    },
  },
  mounted() {
    this.initOne(); // 数据字典
  },
};
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// dictionary.vue?41e2f5e3